<template>
  <DialogTemplate ref="dialogTuto" :close-click-outside="false">
    <template #header><slot name="title"></slot></template>
    <div class="content"><slot /></div>

    <template #footer>
      <div class="actions">
        <ButtonHandNext
          :delay="delayButton"
          class="next"
          @click="handleClickNext"
        />
      </div>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
import { onClickOutside } from '@vueuse/core';

interface Props {
  iconHeader?: string;
  delayButton?: number;
  onNext: Function;
}
const props = defineProps({
  iconHeader: { default: 'fluent-emoji:two-hearts' },
  delayButton: { default: 100 },
  onNext: { type: Function }
});

const dialogTuto = ref<HTMLElement | null>(null);

onClickOutside(dialogTuto, () => {
  props.onNext();
});

const handleClickNext = () => {
  props.onNext();
};
</script>
<style lang="scss" scoped>
.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_n);
  text-align: left;
  p {
    @include font('n', 400);
  }
  :deep(a.direct) {
    @include font('n', 800);

    color: var(--color_secondary);
    text-decoration: underline;
  }
}
</style>
